var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-card-container"},[_c('div',{staticClass:"default-card"},[_c('div',{staticClass:"icon-container"},[_c('i',{class:_vm.data.icon})]),_c('h3',[_vm._v(_vm._s(_vm.data.title))]),_c('p',[_vm._v(_vm._s(_vm.data.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }